/* Apollo vs CrossFire XR comparison: fit finder + cost builder.
   Re-initialises on Shopify theme editor section reloads. */
(function () {
  'use strict';

  var money = function (n) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);
    } catch (e) {
      return '$' + Math.round(n).toLocaleString('en-US');
    }
  };

  /* ---------- Fit finder ---------- */
  function initFinder(root) {
    if (!root || root.dataset.lscReady) return;
    root.dataset.lscReady = '1';
    var form = root.querySelector('[data-lsc-form]');
    var verdict = root.querySelector('[data-lsc-verdict]');
    if (!form || !verdict) return;
    var needle = verdict.querySelector('[data-lsc-needle]');
    var title = verdict.querySelector('[data-lsc-title]');
    var list = verdict.querySelector('[data-lsc-reasons]');
    var ctaA = verdict.querySelector('[data-lsc-cta="apollo"]');
    var ctaX = verdict.querySelector('[data-lsc-cta="xr"]');

    function update() {
      var score = 0, force = false, reasons = [];
      form.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
        score += parseFloat(el.dataset.score || '0') || 0;
        if (el.dataset.force === 'xr') force = 'xr';
        if (el.dataset.force === 'apollo' && !force) force = 'apollo';
        if (el.dataset.reason) reasons.push({ lean: el.dataset.lean || 'none', text: el.dataset.reason });
      });
      if (force === 'xr') score = Math.max(score, 6);
      if (force === 'apollo') score = Math.min(score, -6);

      var lean = score <= -3 ? 'apollo' : score >= 3 ? 'xr' : 'none';
      needle.style.left = Math.max(4, Math.min(96, 50 + score * 6)) + '%';
      verdict.classList.toggle('is-apollo', lean === 'apollo');
      verdict.classList.toggle('is-xr', lean === 'xr');
      title.textContent = verdict.dataset[lean === 'apollo' ? 'titleApollo' : lean === 'xr' ? 'titleXr' : 'titleEither'];

      var shown = reasons.filter(function (r) { return lean === 'none' || r.lean === lean || r.lean === 'none'; }).slice(0, 4);
      if (lean === 'none' && verdict.dataset.eitherReason) shown.push({ text: verdict.dataset.eitherReason });
      list.innerHTML = '';
      shown.forEach(function (r) {
        var li = document.createElement('li');
        li.textContent = r.text;
        list.appendChild(li);
      });
      if (ctaA) ctaA.hidden = lean === 'xr';
      if (ctaX) ctaX.hidden = lean === 'apollo';
    }
    form.addEventListener('change', update);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    update();
  }

  /* ---------- Cost builder ---------- */
  function initCost(root) {
    if (!root || root.dataset.lscReady) return;
    root.dataset.lscReady = '1';
    var cards = root.querySelectorAll('[data-lsc-card]');
    var gap = root.querySelector('[data-lsc-gap]');

    function total(card) {
      var t = (parseFloat(card.dataset.base) || 0) + (parseFloat(card.dataset.freight) || 0);
      var sel = card.querySelector('select');
      if (sel) t += parseFloat(sel.value) || 0;
      card.querySelectorAll('input[type="checkbox"]:checked').forEach(function (c) {
        t += parseFloat(c.dataset.price) || 0;
      });
      return t;
    }
    function update() {
      var totals = [];
      cards.forEach(function (card) {
        var t = total(card);
        totals.push(t);
        var out = card.querySelector('[data-lsc-total]');
        if (out) out.textContent = money(t);
      });
      if (gap && totals.length === 2) gap.textContent = money(Math.abs(totals[0] - totals[1]));
    }
    root.addEventListener('change', update);
    update();
  }

    /* ---------- Package comparison popup ---------- */
  var pkgCache = {};
  var lastTrigger = null;

  function loadComparison(url, selector) {
    var key = url + '|' + selector;
    if (pkgCache[key]) return pkgCache[key];
    pkgCache[key] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector(selector);
        if (!el) throw new Error('not found');
        el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        return el.outerHTML;
      })
      .catch(function (err) { delete pkgCache[key]; throw err; });
    return pkgCache[key];
  }

  function openModal(modal, trigger) {
    var body = modal.querySelector('[data-lsc-modal-body]');
    var url = trigger.getAttribute('data-url');
    var selector = modal.getAttribute('data-selector') || '[id*="package_comparison"]';
    lastTrigger = trigger;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    body.innerHTML = '<p class="lsc-modal__status">Loading…</p>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('lsc-modal-open');
    document.body.classList.add('lsc-modal-open');
    var container = modal.querySelector('.lsc-modal__container');
    if (container) container.focus();
    loadComparison(url, selector).then(function (html) {
      body.innerHTML = html;
      body.scrollTop = 0;
    }).catch(function () {
      var msg = modal.getAttribute('data-fallback') || "The package comparison couldn't load.";
      body.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'lsc-modal__status';
      p.textContent = msg + ' ';
      var a = document.createElement('a');
      a.href = url;
      a.textContent = 'View it on the product page';
      p.appendChild(a);
      body.appendChild(p);
    });
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lsc-modal-open');
    document.body.classList.remove('lsc-modal-open');
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-lsc-pkg-open]');
    if (trigger) {
      var modal = document.getElementById(trigger.getAttribute('data-target'));
      if (modal) { e.preventDefault(); openModal(modal, trigger); }
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-lsc-close]');
    if (closer) {
      var open = closer.closest('[data-lsc-modal]');
      if (open) closeModal(open);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-lsc-modal].is-open');
    if (open) closeModal(open);
  });

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lsc-finder]').forEach(initFinder);
    (scope || document).querySelectorAll('[data-lsc-cost]').forEach(initCost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
